import React, { useState, useCallback } from 'react';
import { View, Text, StyleSheet, TextInput, Switch, SafeAreaView, Linking, Button, Alert, TouchableOpacity } from 'react-native';
import DropDownPicker from 'react-native-dropdown-picker';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import Constants from 'expo-constants';

const OpenURLButton = ({ url, children }) => {
  const handlePress = useCallback(async () => {
    // Checking if the link is supported for links with custom URL scheme.
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      // Opening the link with some app, if the URL scheme is "http" the web link should be opened
      // by some browser in the mobile
      await Linking.openURL(url);
    } else {
      Alert.alert(`Don't know how to open this URL: ${url}`);
    }
  }, [url]);

  return <Button title={children} onPress={handlePress} />;
};

const bpsupplyLink = "https://www.bpsupplyinc.com/pump-selector";
const dfwcreativeLink = "https://dfwcreativemarketing.com";

const VariableScreen = props => {
  const [diameterValue, setDiameterValue] = useState(0.182);
  const [diameterActualValue, setDiameterActualValue] = useState(1.25);

  const [strokeValue, setStrokeValue] = useState(100);
  const [strokeToggleValue, setStrokeToggleValue] = useState(false);
  const strokeToggleSwitch = () => {
    if(strokeToggleValue === false){
      setStrokeToggleValue(previousState => !previousState);
    };
    if(strokeSpeedToggleValue === true){
      setStrokeSpeedToggleValue(previousState => !previousState);
    };
    if(runTimeToggleValue === true){
      setRunTimeToggleValue(previousState => !previousState);
    };
    if(pumpEfficiencyToggleValue === true){
      setPumpEfficiencyToggleValue(previousState => !previousState);
    };
    if(bpdToggleValue === true){
      setBpdToggleValue(previousState => !previousState);
    };
  };

  const [strokeSpeedValue, setStrokeSpeedValue] = useState(7);
  const [strokeSpeedToggleValue, setStrokeSpeedToggleValue] = useState(false);
  const strokeSpeedToggleSwitch = () => {
    if(strokeToggleValue === true){
      setStrokeToggleValue(previousState => !previousState);
    };
    if(strokeSpeedToggleValue === false){
      setStrokeSpeedToggleValue(previousState => !previousState);
    };
    if(runTimeToggleValue === true){
      setRunTimeToggleValue(previousState => !previousState);
    };
    if(pumpEfficiencyToggleValue === true){
      setPumpEfficiencyToggleValue(previousState => !previousState);
    };
    if(bpdToggleValue === true){
      setBpdToggleValue(previousState => !previousState);
    };
  };

  const [runTimeValue, setRunTimeValue] = useState(24);
  const [runTimeToggleValue, setRunTimeToggleValue] = useState(false);
  const runTimeToggleSwitch = () => {
    if(strokeToggleValue === true){
      setStrokeToggleValue(previousState => !previousState);
    };
    if(strokeSpeedToggleValue === true){
      setStrokeSpeedToggleValue(previousState => !previousState);
    };
    if(runTimeToggleValue === false){
      setRunTimeToggleValue(previousState => !previousState);
    };
    if(pumpEfficiencyToggleValue === true){
      setPumpEfficiencyToggleValue(previousState => !previousState);
    };
    if(bpdToggleValue === true){
      setBpdToggleValue(previousState => !previousState);
    };
  };

  const [pumpEfficiencyValue, setPumpEfficiencyValue] = useState(80);
  const [pumpEfficiencyToggleValue, setPumpEfficiencyToggleValue] = useState(false);
  const pumpEfficiencyToggleSwitch = () => {
    if(strokeToggleValue === true){
      setStrokeToggleValue(previousState => !previousState);
    };
    if(strokeSpeedToggleValue === true){
      setStrokeSpeedToggleValue(previousState => !previousState);
    };
    if(runTimeToggleValue === true){
      setRunTimeToggleValue(previousState => !previousState);
    };
    if(pumpEfficiencyToggleValue === false){
      setPumpEfficiencyToggleValue(previousState => !previousState);
    };
    if(bpdToggleValue === true){
      setBpdToggleValue(previousState => !previousState);
    };
  };

  const [bpdValue, setBpdValue] = useState(101.92);
  const [bpdToggleValue, setBpdToggleValue] = useState(true);
  const bpdToggleSwitch = () => {
    if(strokeToggleValue === true){
      setStrokeToggleValue(previousState => !previousState);
    };
    if(strokeSpeedToggleValue === true){
      setStrokeSpeedToggleValue(previousState => !previousState);
    };
    if(runTimeToggleValue === true){
      setRunTimeToggleValue(previousState => !previousState);
    };
    if(pumpEfficiencyToggleValue === true){
      setPumpEfficiencyToggleValue(previousState => !previousState);
    };
    if(bpdToggleValue === false){
      setBpdToggleValue(previousState => !previousState);
    };
  };

  const [oilGravityValue, setOilGravityValue] = useState(40);
  const [waterCutValue, setWaterCutValue] = useState(50);
  const [waterGravityValue, setWaterGravityValue] = useState(1);
  const [specificGravityValue, setSpecificGravityValue] = useState(0.912536);

  const [pumpDepthValue, setPumpDepthValue] = useState(11000);
  const [tubingPressureValue, setTubingPressureValue] = useState(50);
  const [casingPressureValue, setCasingPressureValue] = useState(100);
  //const [pressureDifferientialValue, setPressureDifferientialValue] = useState(4296.411);
  const [plungerClearanceValue, setPlungerClearanceValue] = useState(.005);
  const [plungerLengthValue, setPlungerLengthValue] = useState(72);
  const [fluidViscosityValue, setFluidViscosityValue] = useState(.76);
  //const [slippageValue, setSlippageValue] = useState(27.99417);
  //const [advancedPumpEfficiencyValue, setAdvancedPumpEfficiencyValue] = useState(0.780266);
  const [advancedBpdValue, setAdvancedBpdValue] = useState(99.40583);

  const bpd = Math.round(((diameterValue * strokeValue * strokeSpeedValue * (runTimeValue/24) * (pumpEfficiencyValue/100)) + Number.EPSILON));
  const bpdString = bpd.toString();
  const strokeLength = Math.round(((bpdValue/(diameterValue * strokeSpeedValue * (runTimeValue/24) * (pumpEfficiencyValue/100))) + Number.EPSILON) * 100) / 100;
  const strokeLengthString = strokeLength.toString();
  const strokeSpeed = Math.round(((bpdValue/(diameterValue * strokeValue * (runTimeValue/24) * (pumpEfficiencyValue/100))) + Number.EPSILON) * 100) / 100;
  const strokeSpeedString = strokeSpeed.toString();
  const runTime = Math.round(((bpdValue * 24/(diameterValue * strokeValue * strokeSpeedValue * (pumpEfficiencyValue/100))) + Number.EPSILON) * 100) / 100;
  const runTimeString = runTime.toString();
  const pumpEfficiencyRounded = Math.round((pumpEfficiencyValue + Number.EPSILON) * 100) / 100;
  const pumpEfficiencyString = pumpEfficiencyRounded.toString();

  const specificGravity = Math.round((((( 141.5 / ( oilGravityValue + 131.5 )) * ( 1 - ( waterCutValue / 100)))+( waterGravityValue * ( waterCutValue / 100 ))) + Number.EPSILON) * 100) / 100;
  const pressureDifferiential = Math.round((((0.433 * (((141.5 / (oilGravityValue + 131.5)) * (1 - (waterCutValue/100))) + (waterGravityValue * (waterCutValue/100))) * pumpDepthValue) + (tubingPressureValue - casingPressureValue)) + Number.EPSILON) * 100) / 100;
  const slippage = Math.round((((0.14 * strokeSpeedValue) + 1) * 453 * ((diameterActualValue * ((0.433 * (((141.5 / (oilGravityValue + 131.5)) * (1 - (waterCutValue/100))) + (waterGravityValue * (waterCutValue/100))) * pumpDepthValue) + (tubingPressureValue - casingPressureValue)) * Math.pow(plungerClearanceValue, 1.52))/(plungerLengthValue*fluidViscosityValue)) + Number.EPSILON) * 100) / 100;
  const advancedPumpEfficiency = Math.round(((1-(slippage/(diameterValue*strokeValue*strokeSpeedValue*(runTimeValue/24)*1))) + Number.EPSILON) * 100) / 100;
  const advancedDailyProduction = Math.round((((diameterValue*strokeValue*strokeSpeedValue*(runTimeValue/24)*((1-(slippage/(diameterValue*strokeValue*strokeSpeedValue*(runTimeValue/24)*1)))))) + Number.EPSILON));

  return (
    <SafeAreaView style={styles.safeArea}>
      <KeyboardAwareScrollView style={styles.body}>
        <Text style={styles.title}>Basic Calculator</Text>
        <Text style={styles.variableName}>Plunger Diameter in Inches</Text>
        <DropDownPicker
          items={[
            {label:"1.0625", value:"0.132"},
            {label:"1.250", value:"0.182", selected: true},
            {label:"1.500", value:"0.262"},
            {label:"1.750", value:"0.357"},
            {label:"2.000", value:"0.468"},
            {label:"2.250", value:"0.59"},
            {label:"2.500", value:"0.728"},
            {label:"2.775", value:"0.881"},
            {label:"3.250", value:"1.231"},
            {label:"3.750", value:"1.639"}
          ]}
          defaultIndex={1}
          containerStyle={{height: 40}}
          onChangeItem={item => {
            setBpdValue(item.value * strokeValue * strokeSpeedValue * (runTimeValue/24) * (pumpEfficiencyValue/100));
            setDiameterValue(Number(item.value));
            setDiameterActualValue(Number(item.label));
          }}
        />

        <Text style={styles.variableName}>Downhole Stroke Length</Text>
        <View style={styles.variableEntry}>
          <View style={styles.inputCurrent}>
            <TextInput style={styles.input}
              keyboardType="decimal-pad"
              onChangeText={(newValue) => {
                const numberValue = Number(newValue);
                if(strokeToggleValue === true){
                  setStrokeValue(strokeValue);
                } else {
                  if(strokeSpeedToggleValue === true){
                    setStrokeSpeedValue(bpdValue/(diameterValue * numberValue * (runTimeValue/24) * (pumpEfficiencyValue/100)));
                    setStrokeValue(numberValue);
                  };
                  if(runTimeToggleValue === true){
                    setRunTimeValue(bpdValue * 24/(diameterValue * numberValue * strokeSpeedValue * (pumpEfficiencyValue/100)));
                    setStrokeValue(numberValue);
                  };
                  if(pumpEfficiencyToggleValue === true){
                    setPumpEfficiencyValue(bpdValue * 100 /(diameterValue * numberValue * strokeSpeedValue * (runTimeValue/24)));
                    setStrokeValue(numberValue);
                  };
                  if(bpdToggleValue === true){
                    setBpdValue(diameterValue * numberValue * strokeSpeedValue * (runTimeValue/24) * (pumpEfficiencyValue/100));
                    setStrokeValue(numberValue);
                  };
                };

              }}
              value={strokeLengthString}
            />
            <Text style={styles.current}>
               Inches</Text>
          </View>
          <View style={styles.currentCalculate}>
            <Text style={styles.current}>Calculate Length</Text>
            <Switch
              rackColor={{ false: "#767577", true: "#81b0ff" }}
              thumbColor={strokeToggleValue ? "#f5dd4b" : "#f4f3f4"}
              ios_backgroundColor="#3e3e3e"
              onValueChange={strokeToggleSwitch}
              value={strokeToggleValue}
            />
          </View>
        </View>

        <Text style={styles.variableName}>Stroke Speed</Text>
        <View style={styles.variableEntry}>
          <View style={styles.inputCurrent}>
            <TextInput style={styles.input}
              keyboardType="decimal-pad"
              onChangeText={(newValue) => {
                const numberValue = Number(newValue);
                if(strokeSpeedToggleValue === true){
                  setStrokeSpeedValue(strokeSpeedValue);
                } else {
                  if(strokeToggleValue === true){
                    setStrokeValue(bpdValue/(diameterValue * numberValue * (runTimeValue/24) * (pumpEfficiencyValue/100)));
                    setStrokeSpeedValue(numberValue);
                  }
                  if(runTimeToggleValue === true){
                    setRunTimeValue(bpdValue * 24/(diameterValue * numberValue * strokeValue * (pumpEfficiencyValue/100)));
                    setStrokeSpeedValue(numberValue);
                  };
                  if(pumpEfficiencyToggleValue === true){
                    setPumpEfficiencyValue(bpdValue * 100/(diameterValue * numberValue * strokeValue * (runTimeValue/24)));
                    setStrokeSpeedValue(numberValue);
                  };
                  if(bpdToggleValue === true){
                    setBpdValue(diameterValue * numberValue * strokeValue * (runTimeValue/24) * (pumpEfficiencyValue/100));
                    setStrokeSpeedValue(numberValue);
                  };
                };
              }}
              value={strokeSpeedString}
            />
            <Text style={styles.current}>Stokes/ Minute</Text>
          </View>
          <View style={styles.currentCalculate}>
            <Text style={styles.current}>Calculate Speed</Text>
            <Switch
              rackColor={{ false: "#767577", true: "#81b0ff" }}
              thumbColor={strokeSpeedToggleValue ? "#f5dd4b" : "#f4f3f4"}
              ios_backgroundColor="#3e3e3e"
              onValueChange={strokeSpeedToggleSwitch}
              value={strokeSpeedToggleValue}
            />
          </View>
        </View>

        <Text style={styles.variableName}>Run Time</Text>
        <View style={styles.variableEntry}>
          <View style={styles.inputCurrent}>
            <TextInput style={styles.input}
              keyboardType="decimal-pad"
              onChangeText={(newValue) => {
                const numberValue = Number(newValue);
                if(runTimeToggleValue === true){
                  setRunTimeValue(runTimeValue);
                } else {
                  if(strokeToggleValue === true){
                    setStrokeValue(bpdValue/(diameterValue * strokeValue * (numberValue/24) * (pumpEfficiencyValue/100)));
                    setRunTimeValue(numberValue);
                  }
                  if(strokeSpeedToggleValue === true){
                    setStrokeSpeedValue(bpdValue/(diameterValue * strokeValue * (numberValue/24) * (pumpEfficiencyValue/100)));
                    setRunTimeValue(numberValue);
                  };
                  if(pumpEfficiencyToggleValue === true){
                    setPumpEfficiencyValue(bpdValue * 100 /(diameterValue * strokeValue * strokeSpeedValue * (numberValue/24)));
                    setRunTimeValue(numberValue);
                  };
                  if(bpdToggleValue === true){
                    setBpdValue(diameterValue * strokeValue * strokeSpeedValue * (numberValue/24) * (pumpEfficiencyValue/100));
                    setRunTimeValue(numberValue);
                  };
                };
              }}
              value={runTimeString}
            />
            <Text style={styles.current}>Hours/ Day</Text>
          </View>
          <View style={styles.currentCalculate}>
            <Text style={styles.current}>Calculate Run Time</Text>
            <Switch
              rackColor={{ false: "#767577", true: "#81b0ff" }}
              thumbColor={runTimeToggleValue ? "#f5dd4b" : "#f4f3f4"}
              ios_backgroundColor="#3e3e3e"
              onValueChange={runTimeToggleSwitch}
              value={runTimeToggleValue}
            />
          </View>
        </View>

        <Text style={styles.variableName}>Pump Efficiency</Text>
        <View style={styles.variableEntry}>
          <View style={styles.inputCurrent}>
            <TextInput style={styles.input}
              keyboardType="decimal-pad"
              onChangeText={(newValue) => {
                const numberValue = Number(newValue);
                if(pumpEfficiencyToggleValue === true){
                  setPumpEfficiencyValue(pumpEfficiencyValue);
                } else {
                  if(strokeToggleValue === true){
                    setStrokeValue(bpdValue/(diameterValue * (runTimeValue/24) * (numberValue/100)));
                    setPumpEfficiencyValue(numberValue);
                  }
                  if(strokeSpeedToggleValue === true){
                    setStrokeSpeedValue(bpdValue/(diameterValue * strokeValue * (runTimeValue/24) * (numberValue/100)));
                    setPumpEfficiencyValue(numberValue);
                  };
                  if(runTimeToggleValue === true){
                    setRunTimeValue(bpdValue * 24/(diameterValue * strokeValue * strokeSpeedValue * (numberValue/100)));
                    setPumpEfficiencyValue(numberValue);
                  };
                  if(bpdToggleValue === true){
                    setBpdValue(diameterValue * strokeValue * strokeSpeedValue * (runTimeValue/24) * (numberValue/100));
                    setPumpEfficiencyValue(numberValue);
                  };
                };
              }}
              value={pumpEfficiencyString}
            />
            <Text style={styles.current}>%</Text>
          </View>
          <View style={styles.currentCalculate}>
            <Text style={styles.current}>Calculate Efficiency</Text>
            <Switch
              rackColor={{ false: "#767577", true: "#81b0ff" }}
              thumbColor={pumpEfficiencyToggleValue ? "#f5dd4b" : "#f4f3f4"}
              ios_backgroundColor="#3e3e3e"
              onValueChange={pumpEfficiencyToggleSwitch}
              value={pumpEfficiencyToggleValue}
            />
          </View>
        </View>

        <Text style={styles.variableName}>Daily Production</Text>
        <View style={styles.variableEntry}>
          <View style={styles.inputCurrent}>
            <TextInput style={styles.input}
              keyboardType="decimal-pad"
              onChangeText={(newValue) => {
                const numberValue = Number(newValue);
                if(bpdToggleValue === true){
                  setBpdValue(bpdValue);
                } else {
                  if(strokeToggleValue === true){
                    setStrokeValue(numberValue/(diameterValue * strokeSpeedValue * (runTimeValue/24) * (pumpEfficiencyValue/100)));
                    setBpdValue(numberValue);
                  }
                  if(strokeSpeedToggleValue === true){
                    setStrokeSpeedValue(numberValue/(diameterValue * strokeValue * (runTimeValue/24) * (pumpEfficiencyValue/100)));
                    setBpdValue(numberValue);
                  };
                  if(runTimeToggleValue === true){
                    setRunTimeValue(numberValue * 24/(diameterValue * strokeValue * strokeSpeedValue * (pumpEfficiencyValue/100)));
                    setBpdValue(numberValue);
                  };
                  if(pumpEfficiencyToggleValue === true){
                    setPumpEfficiencyValue(numberValue * 100 /(diameterValue * strokeValue * strokeSpeedValue * (runTimeValue/24)));
                    setBpdValue(numberValue);
                  };
                };
              }}
              value={bpdString}
            />
            <Text style={styles.current}>BPD</Text>
          </View>
          <View style={styles.currentCalculate}>
            <Text style={styles.current}>Calculate BPD</Text>
            <Switch
              rackColor={{ false: "#767577", true: "#81b0ff" }}
              thumbColor={bpdToggleValue ? "#f5dd4b" : "#f4f3f4"}
              ios_backgroundColor="#3e3e3e"
              onValueChange={bpdToggleSwitch}
              value={bpdToggleValue}
            />
          </View>
        </View>

        <Text style={styles.title}>Advanced Calculator</Text>

        <Text style={styles.variableName}>Oil Gravity</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ oilGravityValue }</Text> API</Text>
          <TextInput style={styles.input}
            keyboardType="decimal-pad"
            onChangeText={(newValue) => {
              setOilGravityValue(Number(newValue));
              setWaterCutValue(Number(waterCutValue));
              setWaterGravityValue(Number(waterGravityValue));
              setSpecificGravityValue(Number(specificGravity));
            }}
          />
        </View>

        <Text style={styles.variableName}>Water Cut</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ waterCutValue }</Text>%</Text>
          <TextInput style={styles.input}
            keyboardType="decimal-pad"
            onChangeText={(newValue) => {
              setWaterGravityValue(Number(waterGravityValue));
              setOilGravityValue(Number(oilGravityValue));
              setWaterCutValue(Number(newValue));
              setSpecificGravityValue(Number(specificGravity));
            }}
          />
        </View>

        <Text style={styles.variableName}>Specific Gravity of Water</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ waterGravityValue }</Text></Text>
          <TextInput style={styles.input}
            keyboardType="decimal-pad"
            onChangeText={(newValue) => {
              setWaterCutValue(Number(waterCutValue));
              setOilGravityValue(Number(oilGravityValue));
              setWaterGravityValue(Number(newValue));
              setSpecificGravityValue(Number(specificGravity));
            }}
          />
        </View>

        <Text style={styles.variableName}>Total Specific Gravity</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ specificGravity }</Text></Text>
        </View>

        <Text style={styles.variableName}>Pump Depth</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ pumpDepthValue }</Text> Feet</Text>
          <TextInput style={styles.input}
            keyboardType="decimal-pad"
            onChangeText={(newValue) => {
              setPumpDepthValue(Number(newValue));
            }}
          />
        </View>

        <Text style={styles.variableName}>Tubing Pressure</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ tubingPressureValue }</Text> PSI</Text>
          <TextInput style={styles.input}
            keyboardType="decimal-pad"
            onChangeText={(newValue) => {
              setTubingPressureValue(Number(newValue));
            }}
          />
        </View>

        <Text style={styles.variableName}>Casing Pressure</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ casingPressureValue }</Text> PSI</Text>
          <TextInput style={styles.input}
            keyboardType="decimal-pad"
            onChangeText={(newValue) => {
              setCasingPressureValue(Number(newValue));
            }}
          />
        </View>

        <Text style={styles.variableName}>Pressure Differiential</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ pressureDifferiential }</Text></Text>
        </View>

        <Text style={styles.variableName}>Overall Plunger / BBL Clearance</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ plungerClearanceValue }</Text> Inches</Text>
          <TextInput style={styles.input}
            keyboardType="decimal-pad"
            onChangeText={(newValue) => {
              setPlungerClearanceValue(Number(newValue));
            }}
          />
        </View>

        <Text style={styles.variableName}>Length of Plunger</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ plungerLengthValue }</Text> Inches</Text>
          <TextInput style={styles.input}
            keyboardType="decimal-pad"
            onChangeText={(newValue) => {
              setPlungerLengthValue(Number(newValue));
            }}
          />
        </View>

        <View style={styles.variableNameWithIcon}>
          <Text style={styles.variableIconName}>Fluid Viscosity</Text>
          <TouchableOpacity
            onPress={() => props.navigation.navigate('ViscosityDetails')}
          >
            <Text style={styles.variableNameIcon}>View Fluid Viscosity Details</Text>
          </TouchableOpacity>
        </View>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ fluidViscosityValue }</Text> CP</Text>
          <TextInput style={styles.input}
            keyboardType="decimal-pad"
            onChangeText={(newValue) => {
              setFluidViscosityValue(Number(newValue));
            }}
          />
        </View>

        <Text style={styles.variableName}>Slippage</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ slippage }</Text> BBL/Day</Text>
        </View>

        <Text style={styles.variableName}>Pump Efficency</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ advancedPumpEfficiency * 100 }</Text>%</Text>
        </View>

        <Text style={styles.variableName}>Advanced Daily Production</Text>
        <View style={styles.variableEntry}>
          <Text style={styles.current}><Text style={styles.value}>{ advancedDailyProduction }</Text> BPD</Text>
        </View>

      </KeyboardAwareScrollView>
      <View>
        <OpenURLButton url={bpsupplyLink}>Contact BP Supply for Help</OpenURLButton>
        <OpenURLButton url={dfwcreativeLink}>App Design by DFW Creative Marketing</OpenURLButton>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    marginTop: Constants.statusBarHeight,
  },
  title: {
    fontSize: 25,
    marginVertical: 10
  },
  body: {
    margin: 10
  },
  variableName: {
    fontSize: 10,
    padding: 5,
    backgroundColor: "rgb(137,24,0)",
    color: "white",
    borderWidth: 2,
    borderColor: "black"
  },
  variableIconName: {
    fontSize: 10,
    padding: 5,
    backgroundColor: "rgb(137,24,0)",
    color: "white",
  },
  variableNameWithIcon: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "rgb(137,24,0)",
    color: "white",
    borderWidth: 2,
    borderColor: "black"
  },
  variableNameIcon: {
    fontSize: 10,
    color: "white",
    backgroundColor: "blue",
    padding: 5,
    borderRadius: 5,
  },
  inputCurrent: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "20%"
  },
  currentCalculate: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "65%"
  },
  variableEntry: {
    padding: 5,
    backgroundColor: "grey",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  value: {
    fontSize: 20
  },
  input: {
    padding: 2,
    marginHorizontal: 10,
    backgroundColor: "white",
    borderColor: "black",
    borderWidth: 1,
    width: 50,
  },
  current: {
    padding: 5,
    color: "white"
  }
});

export default VariableScreen;
